<template>
  <div class="flex justify-center rounded-lg mx-2 mt-2 md:mt-6">
    <div class="md:w-5/12">
      <div
        class="container mx-auto px-4 p-1 bg-basic-dark shadow-md drop-shadow-2xl lg:p-2 rounded-md place-items-center"
      >
        <auth-carsouel />
        <div class="">
          <h5
            dir="rtl"
            class="my-3 text-md text-lg text-white font-bold font-Almarai text-center"
          >
            قم بالدخول واستمتع بمشاهدة البرامج والقنوات بلا حدود
          </h5>
          <!-- <div  class="border border-b-2 border-pink-500  mx-2 mx-auto mt-1 w-36"></div> -->

          <div class="m-3 relative md:w-96 mx-auto" dir="rtl">
            <label for="mobile" class="text-white">رقم الهاتف (STC السعودية)</label>
            <phone-svg />
            <input
              type="tel"
              class="bg-gray-900 border border-color focus:ring-pink-500 focus:border-pink-500 text-gray-900 text-sm rounded-sm w-full my-1"
              v-model="phone"
              placeholder="مثال: 0501234567 أو 9665012345678"
              maxlength="13"
              required
            />
          </div>

          <div class="flex justify-center my-6">
            <button
              type="submit"
              :disabled="isLoading"
              :class="{ 'opacity-50 cursor-not-allowed': isLoading }"
              class="text-white focus:ring-0 focus:outline-none focus:ring-pink-300 rounded-lg text-md md:w-96  px-5 py-2.5 text-center btn-color cursor-pointer w-full absloute z-20"
              @click="login"
            >
              <span v-if="!isLoading">دخول الآن!</span>
              <span v-else>جارٍ التحقق...</span>
            </button>
          </div>

          <div class="text-white hidden" dir="rtl">
            <p
              class="text-center font-small m-2 font-Almarai mt-2"
              style="font-size: 11px; line-height: 15px"
            >
              قيمة الاشتراك اليومي لكل المقاطع والبرامج 120 جنيه فقط شاملة
              الضريبة تجدد تلقائيا عبر شبكة سوداني
            </p>
          </div>
          <!-- hello -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthCarsouel from "@/components/shared/AuthCarsouel.vue";
import PhoneSvg from "@/components/svg/PhoneSvg";
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import { useToast } from "vue-toastification";
import { validateStcPhone } from "@/util/validation.js";

export default {
  components: {
    AuthCarsouel,
    PhoneSvg,
  },
  data() {
    return {
      phone: "",
      toast: useToast(),
      isLoading: false,
      error: false,
      errorNotSubscribed: false,
      message: "رقم الهاتف غير صحيح. يجب أن يكون رقم STC صحيح (050، 053، 055، 058، 059)",
      messageNotSuscribed: "أنت غير مشترك في الخدمة. قم بالإشتراك الآن",
    };
  },
  methods: {
    ...mapActions(useAuthStore, ["checkSubescriptionStatus"]),
    async login() {
      // Check for empty input
      if (!this.phone || this.phone.trim() === "") {
        this.toast.error("يرجى إدخال رقم الهاتف");
        return false;
      }

      // Prevent multiple submissions
      if (this.isLoading) return;

      // Validate STC Saudi phone number
      const validation = validateStcPhone(this.phone.toString().trim());
      
      if (!validation.valid) {
        this.toast.error(this.message);
        this.error = true;
        return false;
      }

      // Use the validated phone number
      const validatedNumber = validation.phoneNumber;
      console.log('Validated STC phone number:', validatedNumber);

      this.isLoading = true;
      this.error = false;

      try {
        // Call subscription status check with validated number
        const response = await this.checkSubescriptionStatus(validatedNumber);
        this.redirect(response);
      } catch (error) {
        console.error("Login error:", error);
        this.toast.error("حدث خطأ أثناء تسجيل الدخول. يرجى المحاولة مرة أخرى.");
      } finally {
        this.isLoading = false;
      }
    }, //end of subscription method
    close() {
      return (this.error = false);
    },
    redirect(response) {
      
      // Check if user has active subscription
      if (response.data.success || response.data.isActive) {
        this.toast.success("تم تسجيل الدخول بنجاح");
        setTimeout(() => {
          this.$router.push({ name: "home" });
        }, 1000);
      }  else {
        this.toast.error("حدث خطأ. يرجى التحقق من رقم الهاتف أو الاشتراك.");
        setTimeout(() => {
          this.$router.push("/auth/subscribe");
        }, 2000);
      }
    },
  },
};
</script>

<style scoped>
.width-height {
  width: 900px;
  height: auto;
}
.xxsm {
  width: 255px;
}
.w-btn {
  width: 290px;
  align-self: right;
}

.btn-color {
  background-color: #9d2890;
}

.bg-basic {
  background-color: #181b30;
}

input {
  text-align: center;
  outline: none;
  padding-left: 5px;
  color: aliceblue;
}

::-webkit-input-placeholder {
  text-align: center;
}

:-moz-placeholder {
  text-align: center;
}
.font-small {
  font-size: 16px;
}
</style>
